<template>
  <div id="hello">
      <div id="render-wrapper">
          <Render v-bind:isDay="isDay"></Render>
          <button v-on:click="isDay = !isDay" id="toggle-day-night" class="button">Front / Tył</button>
      </div>

      <h1 id="main-title" style="min-width: 200px;">
          O nas
      </h1>


      <div id="content" style="padding-bottom: 4em;">




          <section class="section">
              <div class="container  is-fluid">
                  <div class="columns">
                      <div class="column is-two-fifths">
                          <a @click="index = 0"><img :src="photos[0]"   v-animate-onscroll="'animated'" class="fadeInDown"></a>
                          <p class="subtitle"></p>
                      </div>
                      <div class="column is-three-fifths">
                          
                          <p>Helvetia City sp. z o.o. istnieje na rynku deweloperskim do 2018 roku. Została powołana do realizacji przedsięwcięcia deweloperskiego „Wenus Mieszkania” przy ul. Jutrzenki w Lublinie. Była to pierwsza realizacja Spółki, warto jednak podkreślić, że jej Wspólnicy dzialają na lubelskim rynku deweloperskim od 2007 roku, a więc od ponad piętnastu lat. Stąd kolejna, tym razem kameralna inwestycja o wdzięcznej nazwie „Kaczeńcova”. Spółka Helvetia City sp. z o.o. kontynuuje podjęte we wcześniejszych latach przez Wspólników działania na rynku deweloperskim.</p>
                      </div>
                  </div>

              </div>
          </section>

          <section class="section">
              <div class="container  is-fluid">
                  <div class="columns" style="flex-direction: row-reverse;">
                      <div class="column is-two-fifths">
                          <a @click="index = 0"><img :src="photos[1]"   v-animate-onscroll="'animated'" class="fadeInDown"></a>
                          <p class="subtitle"></p>
                      </div>
                      <div class="column is-three-fifths">
                          
                         <h3>Nasze poprzednie inwestycje</h3>
                         <p>
                          Helvetia nie zamierza się zatrzymywać. Jedną z naszych wyjątkowych inwestycji są Apartamenty Art Deco Spokojna 10, które powstały w centrum Lublina w historycznym budynku dawnej szkoły. Za realizację tego niezwykłego projektu odpowiada spółka Helvetia Investment 2 Sp. z o.o. Budynek przekształcił się w piękne apartamenty w nowoczesnym stylu. Oczywiście miało to miejsce z uwzględnieniem zasad stosowanych w przypadku architektury zabytkowej i z dużą dbałością o detale.</p><p>
Obecnie trwają pracę nad inwestycją Wenus Mieszkania przy ul. Jutrzenki na Czubach. W tej lokalizacji powstaje piękny, nowoczesny budynek, w którym każdy znajdzie dla siebie wymarzone mieszkanie. Nad tym projektem czuwa spółka Helvetia City.
                         </p>
                      </div>
                  </div>

              </div>
          </section>

          <hr>

          <section class="section">
              <div class="container  is-fluid">
                  <div class="columns">
                      <div class="column is-full" style="text-align: center;">
                          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2498.299678880955!2d22.499952876301858!3d51.23197553078707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTHCsDEzJzU1LjEiTiAyMsKwMzAnMDkuMSJF!5e0!3m2!1spl!2spl!4v1693394007866!5m2!1spl!2spl" height="350" frameborder="0" style="border:0; width: 100%; filter: grayscale(100)" allowfullscreen="" aria-hidden="false" tabindex="0" ></iframe>   </div>
                  </div>

              </div>
          </section>





      </div>

      <CoolLightBox
              :items="photos"
              :index="index"
              @close="index = null">
      </CoolLightBox>
  </div>
</template>

<script>
  import Render from "../components/Render";
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
      name: 'About',
      data() {
          return {
              isDay: true,
              photos: [ require('@/assets/img/cam10_noc-slup.jpg'),
                          require('@/assets/img/spokojna-front.jpg')],
              index: null
          }
      },
      props: {
          msg: String
      },
      methods: {
          redirect(route) {
              this.$router.push(route);
          }
      },

      components: {
          Render: Render, CoolLightBox
      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
